import React from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
// Icons
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import PlagiarismOutlinedIcon from "@mui/icons-material/PlagiarismOutlined";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import SavedSearchIcon from "@mui/icons-material/SavedSearch";
import SearchCircle from "../../assets/img/search-builder.png";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
// Assets
import "./style.css";
import { Stack } from "@mui/system";
import { navStyles as sx, StyledLink } from "./Nav.style";
import {
  clearBrowseJournalFullTextLimit,
  getContainOrStartingWIth,
  setSearchKeyword,
} from "../../store/slice/browseJournal";
import { getContainOrStartingWIth as getContainOrStartingWIthforPublisher } from "../../store/slice/browserPublisher";
import { getContainOrStartingWIth as getContainOrStartingWIthForPackage } from "../../store/slice/browsePackage";
import { useDispatch, useSelector } from "react-redux";
import {
  getCardData,
  updateTocPageSearch,
} from "../../store/slice/browseJournal";
import { usagelogApi, usageReport } from "../../api/usageReportApi";
import {
  updateBookCollection,
  updateBrowserPage,
  updateBrowserRow,
  updateSort,
  updateSortName,
} from "../../store/slice/browseFilterSlice";
import { updateVolumeOfTOC } from "../../store/slice/browserFilterSliceDetails";
import api from "../../api/endpoints";
import bookImage from "../../assets/images/book-bookmark.svg";
import {
  clearClassificationNum,
  clearMeshKeyword,
  clearSubstances,
  updateIsNavigatingBack,
} from "../../store/slice/searchSlice";
import { updateBookPublisherCollection } from "../../store/slice/browserFilterSlicePublisher";
import {
  clearSearchedAuthor,
  clearSJRandABDCFilters,
} from "../../store/slice/filterSlice";
import { exitAIMode } from "../../store/slice/aiModeSlice";
import {
  clearNCGAllFilters,
  clearNCGResults,
  updateNCGBrowserPage,
  updateNCGBrowserRow,
} from "../../store/slice/ncgDetailsSlice";
interface SideDrawerProps {
  toggleNav: boolean;
  drawerRef: React.MutableRefObject<null>;
  closeNav: () => void;
}

const SideDrawer = ({ toggleNav, drawerRef, closeNav }: SideDrawerProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const profileData = useSelector((state: any) => state.login);
  const bookUser = useSelector(
    (state: any) => state?.customer?.customerDetails?.datatypes,
  )?.map((item: any) => {
    return item?.dat_resourcetype_id;
  });

  const profileData1 = useSelector(
    (state: any) => state.customer.customerDetails,
  );

  const is_ONOSCustomer = useSelector(
    (state: any) => state.customer.customerDetails?.is_enable_onos,
  );

  const filterReducer = useSelector(
    (state: any) => state.filterReducer?.collectionValue,
  );

  const logBasicSearchUsageData = (usageActionID: any) => {
    const isONOS =
      is_ONOSCustomer && filterReducer === "ONOSCollections" ? 1 : 0;
    const user_ipv4_address =
      sessionStorage.getItem("user_ipv4_address") || null;
    const userMasterId = profileData.user_id ? profileData.user_id : null;
    const informaticscustomerId = profileData.informaticscustomer_id
      ? profileData.informaticscustomer_id
      : null;
    const consortiamasterId =
      profileData1 && profileData1.consortiamaster_id
        ? profileData1.consortiamaster_id
        : null;

    const sessionKey = profileData.session_key ? profileData.session_key : null;
    usagelogApi(
      userMasterId,
      informaticscustomerId,
      consortiamasterId,
      usageActionID,
      null,
      null,
      null,
      null,
      null,
      null,
      // profileData.ip_v4,
      user_ipv4_address,
      null,
      sessionKey,
      1,
      null,
      0,
    );
  };
  // Drawer for mobile screen
  let navItems = [
    // { label: "Search", path: "/search", icon: <SearchOutlinedIcon /> },
    { label: "Search", path: "/initialSearch", icon: <SearchOutlinedIcon /> },
    {
      label: "Search Builder",
      path: "/search-builder",
      icon: (
        <img
          src={SearchCircle}
          alt="Advanced Search"
          style={{ padding: "2px" }}
        />
      ),
    },
    {
      label: "Author Finder",
      path: "/authorfinder",
      icon: <AccountCircleOutlinedIcon />,
    },
    {
      // label: "Journal Finder",
      label: "Publication Finder",
      path: "/BrowseJournalTableSearch",
      icon: <PlagiarismOutlinedIcon />,
    },
  ];
  if (bookUser?.includes(12)) {
    navItems.push({
      label: "Book Finder",
      path: "/BookSearch",
      // icon: <MenuBookOutlinedIcon />,
      icon: (
        <img
          src={bookImage}
          alt="Book Finder"
          style={{
            padding: "2px",
            width: "25px",
            height: "23px",
          }}
        />
      ),
    });
  }

  if (bookUser?.includes(27)) {
    // navItems.push({
    //   // label: "Video Finder",
    //   // label: "Virtual Tumour Board Videos",
    //   label: "VTB Videos",
    //   path: "/ncgFinder",
    //   // icon: <MenuBookOutlinedIcon />,
    //   icon: <PlayCircleOutlineIcon />,
    // });

    navItems.push({
      // label: "Video Finder",
      // label: "Virtual Tumour Board Videos",
      label: "VTB Videos",
      path: "/VTBFinder",
      // icon: <MenuBookOutlinedIcon />,
      icon: <PlayCircleOutlineIcon />,
    });
  }

  function navLinkClick(path: string) {
    if (path === "/search-builder") {
      // usageReport("12");
      dispatch(updateIsNavigatingBack(false));
      logBasicSearchUsageData(12);
    } else if (path === "/authorfinder") {
      // usageReport("15");
      dispatch(updateIsNavigatingBack(false));
      logBasicSearchUsageData(15);
    } else if (path === "/BrowseJournalTableSearch") {
      // usageReport("76");
      logBasicSearchUsageData(76);
      // } else if (path === "/search") {
    } else if (path === "/initialSearch") {
      // usageReport("76");
      logBasicSearchUsageData(8);
      dispatch(updateIsNavigatingBack(false));
    } else if (path === "/BookSearch") {
      // usageReport("76");
      logBasicSearchUsageData(122);
      dispatch(updateIsNavigatingBack(false));
    }
    dispatch(clearSJRandABDCFilters());
    dispatch(getCardData({}));
    dispatch(updateTocPageSearch([]));
    dispatch(
      setSearchKeyword({
        searchType: "",
        words: "",
      }),
    );
    navigate(path);
    closeNav();
  }

  const handleSearchHistory = () => {
    navigate("/searchhistory");
    closeNav();
  };

  const handleMarkedResultpage = () => {
    navigate("/marked-result");
    closeNav();
  };

  return (
    <Box
      ref={drawerRef}
      // width={bookUser?.includes(27) ? 320 : 250}
      width={250}
      position={"fixed"}
      sx={{
        ...sx.drawerWrapper,
        // transform: toggleNav ? "translateX(0)" : "translateX(-250px)",
        transform: toggleNav
          ? "translateX(0)"
          : `translateX(-${bookUser?.includes(27) ? 320 : 250}px)`,
        paddingTop: "60px",
      }}
    >
      <List>
        {navItems?.map((item, i) => (
          <Stack
            key={i}
            direction={"row"}
            alignItems="center"
            sx={{
              ...sx.drawerItem,
            }}
          >
            {item.icon}
            <ListItem
              key={item.label}
              onClick={() => {
                dispatch(updateSort("resource_name_tk asc"));
                // dispatch(updateSortName("Journal"));
                dispatch(updateSortName("Title"));
                // dispatch(updateSort("sjr_score desc"));
                // dispatch(updateSortName("SJR"));
                sessionStorage.setItem("getTabSwitch", "0");
                navLinkClick(item.path);
                dispatch(updateVolumeOfTOC(""));
                dispatch(updateBrowserRow(15));
                dispatch(updateBrowserPage(1));
                dispatch(clearMeshKeyword());
                dispatch(clearSubstances());
                dispatch(clearClassificationNum());
                dispatch(getContainOrStartingWIth("Starting With"));
                dispatch(getContainOrStartingWIthforPublisher("Starting With"));
                dispatch(getContainOrStartingWIthForPackage("Starting With"));
                dispatch(updateBookCollection(""));
                dispatch(updateBookPublisherCollection(""));
                dispatch(clearBrowseJournalFullTextLimit());
                dispatch(clearSearchedAuthor());
                dispatch(exitAIMode());
                dispatch(clearNCGResults());
                dispatch(clearNCGAllFilters());
                dispatch(updateNCGBrowserPage(1));
                dispatch(updateNCGBrowserRow(15));
              }}
              sx={{ cursor: "pointer" }}
            >
              <StyledLink sx={sx.styledLink}>{item.label}</StyledLink>
            </ListItem>
          </Stack>
        ))}
        <Stack
          direction={"row"}
          alignItems="center"
          className="nav-items"
          sx={{
            display: { xs: "flex", sm: "flex", md: "none", lg: "none" },
            paddingLeft: "20px",
          }}
        >
          <ManageSearchIcon />
          <ListItem key={"search-history"}>
            <StyledLink
              sx={sx.styledLink}
              onClick={() => handleSearchHistory()}
            >
              Search History
            </StyledLink>
          </ListItem>
        </Stack>
        <Stack
          direction={"row"}
          alignItems="center"
          className="nav-items"
          sx={{
            display: { xs: "flex", sm: "flex", md: "none", lg: "none" },
            paddingLeft: "20px",
          }}
        >
          <SavedSearchIcon />
          <ListItem key={"mark-res"}>
            <StyledLink
              sx={sx.styledLink}
              onClick={() => handleMarkedResultpage()}
            >
              View Marked Results
            </StyledLink>
          </ListItem>
        </Stack>
      </List>
    </Box>
  );
};

export default SideDrawer;
